import Trends from './Trends.Container';

export default Trends;
